<template>
  <v-container fluid class="pa-0 fill-height">
    <iframe
      :src="url"
      width="100%"
      height="100%"
      frameborder="0"
      allowfullscreen
      style="border: none; min-height: calc(100vh - 64px);"
    ></iframe>
  </v-container>
</template>

<script>
export default {
  name: 'DescuentosEmpleados',
  data() {
    return {
      url: 'https://happytickets.es/ofertas/index.php?track_cat=1&emp=flamenandco&source=15'
    };
  }
};
</script>

<style scoped>
.fill-height {
  height: calc(100vh - 64px);
}
</style>